const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class EvolutionNoteService {
  static async getNotesByPatient(patientId, token) {
    const response = await fetch(`${API_BASE_URL}/evolution-notes/patient/${patientId}`, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al cargar notas');
    return result;
  }

  static async createNote(patientId, content, token, { doctorId, doctorName, noteDate } = {}) {
    const response = await fetch(`${API_BASE_URL}/evolution-notes`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        patientId,
        content,
        ...(doctorId && { doctorId }),
        ...(doctorName && { doctorName }),
        ...(noteDate && { noteDate })
      })
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al crear nota');
    return result;
  }

  static async updateNote(id, content, token, { doctorId, doctorName, noteDate } = {}) {
    const response = await fetch(`${API_BASE_URL}/evolution-notes/${id}`, {
      method: 'PUT',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content,
        ...(doctorId && { doctorId }),
        ...(doctorName && { doctorName }),
        ...(noteDate && { noteDate })
      })
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al actualizar nota');
    return result;
  }

  static async deleteNote(id, token) {
    const response = await fetch(`${API_BASE_URL}/evolution-notes/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al eliminar nota');
    return result;
  }

  static async signNote(id, token) {
    const response = await fetch(`${API_BASE_URL}/evolution-notes/${id}/sign`, {
      method: 'PATCH',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al firmar nota');
    return result;
  }
}

export default EvolutionNoteService;
